import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { SessionKeeperAction } from '../models/session-keeper-action.enum';
import { SessionKeeperConfig } from '../models/session-keeper-config.interface';

@Injectable({
	providedIn: 'root',
})
export class SessionKeeperService {
	#actions$: BehaviorSubject<SessionKeeperAction> = new BehaviorSubject<SessionKeeperAction>(SessionKeeperAction.Idle);
	#config: SessionKeeperConfig | null;
	#timeout: any;

	readonly #http = inject(HttpClient);

	get actions$(): Observable<SessionKeeperAction> {
		return this.#actions$.asObservable();
	}

	extendSession() {
		if (this.#config) {
			this.#http.get(this.#config.url).subscribe();
		}
	}

	reset() {
		if (this.#config) {
			this.#actions$.next(SessionKeeperAction.Running);

			this.startTimer(this.#config.afterMinutes || 25, () => {
				this.#actions$.next(SessionKeeperAction.ShowPopup);

				if (this.#config) {
					console.log('start timer logout');
					this.startTimer(this.#config.popupMinutes || 3, () => {
						this.#actions$.next(SessionKeeperAction.Logout);
					});
				}
			});
		}
	}

	start(config: SessionKeeperConfig) {
		this.#config = config;
		this.reset();
	}

	stop() {
		this.#config = null;
		this.clearTimer();
		this.#actions$.next(SessionKeeperAction.Idle);
	}

	private startTimer(minutes: number, fn: () => void) {
		this.clearTimer();

		const time = minutes * 60 * 1000;
		this.#timeout = setTimeout(() => fn(), time);
	}

	private clearTimer() {
		if (this.#timeout) {
			clearTimeout(this.#timeout);
			this.#timeout = null;
		}
	}
}
